var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container search" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "h2",
          [
            _vm.company && _vm.$canEditCompany(_vm.company_id)
              ? [_vm._v("Manage")]
              : _vm._e(),
            _vm._v("\n                Company"),
            _vm.company ? [_vm._v(" - " + _vm._s(_vm.company.name))] : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _vm.company
          ? _c("div", [
              _vm.company && _vm.$canEditCompany(_vm.company_id)
                ? _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.$laravelRoute(
                          "companies.edit",
                          _vm.company_id
                        )
                      }
                    },
                    [_vm._v("Edit Company")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("strong", [_vm._v("Name")]),
                _vm._v(" " + _vm._s(_vm.company.name) + "\n                ")
              ]),
              _vm._v(" "),
              _c("div", [
                _c("strong", [_vm._v("Website")]),
                _vm._v(" " + _vm._s(_vm.company.website) + "\n                ")
              ]),
              _vm._v(" "),
              _c("div", [
                _c("strong", [_vm._v("Phone")]),
                _vm._v(
                  " " + _vm._s(_vm.company.phone_number) + "\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("h2", { staticClass: "mt-3" }, [_vm._v("Users")]),
                _vm._v(" "),
                _c("div", [
                  _vm.$canManageCompany(_vm.company_id)
                    ? _c(
                        "a",
                        {
                          staticClass: "link",
                          attrs: { href: _vm.$laravelRoute("users.create") }
                        },
                        [_vm._v("Add New User")]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.company.users && _vm.company.users.length
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          staticClass: "list-table",
                          attrs: {
                            responsive: "",
                            fields: _vm.fields,
                            items: _vm.company.users,
                            "show-empty": ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "empty",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n                                No users\n                            "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(data) {
                                  return [
                                    _vm.$canManageCompany(_vm.company_id)
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "link",
                                              attrs: {
                                                href: _vm.$laravelRoute(
                                                  "users.show",
                                                  data.item.id
                                                )
                                              }
                                            },
                                            [_vm._v("View")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "link",
                                              attrs: {
                                                href: _vm.$laravelRoute(
                                                  "users.edit",
                                                  data.item.id
                                                )
                                              }
                                            },
                                            [_vm._v("Edit")]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(manager)",
                                fn: function(data) {
                                  return [
                                    data.item.privileges &&
                                    data.item.privileges.is_company_manager
                                      ? _c("i", {
                                          staticClass:
                                            "fa fa-solid fa-check text-success"
                                        })
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1658129549
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7768b111", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7768b111","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/ShowCompany.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7768b111","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies/ShowCompany.vue
// module chunks = 0